import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'ml-empty-table',
  template: `
    <h4
      *ngIf="!loading && data && data.length === 0"
      class="text-center padding-16"
    >
      {{ message | translate }}
    </h4>
  `,
  styleUrls: ['./empty-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyTableComponent implements OnInit {
  @Input() loading: boolean;
  @Input() data: any[];
  @Input() message = 'no-message';

  constructor() {}

  ngOnInit() {}
}
